import "./style.css";
import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import handsOnImg from "../../../resources/hands_on.jpg";
import lookAndLearnImg from "../../../resources/look_and_learn.jpg";
import oneOnOneImg from "../../../resources/one_on_one.jpg";
import { useNavigate } from "react-router-dom";
import EducationBreadcrumb from "../../../common/EducationBreadcrumb";

export const SingleEducation = () => {
    const phoneNumber = "+381 60-3859-426";
    const navigate = useNavigate();
    const [fadeIn, setFadeIn] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div
            className='page-workshop'
            style={{
                animation: "fadeIn 0.05s ease-in-out",
            }}
        >
            <EducationBreadcrumb />

            <div className={`items-workshop ${fadeIn ? "fade-in" : ""}`}>
                <div
                    style={{
                        backgroundColor: "rgba(27, 29, 33, 0.85)",
                        border: "2px solid #be9455",
                        borderRadius: "12px",
                        padding: "25px 30px",
                        width: "95%",
                        maxWidth: "600px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                        marginBottom: "30px",
                        marginTop: "-20px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "24px",
                            textAlign: "center",
                            width: "100%",
                            color: "#f3f3f3",
                            lineHeight: "1.5",
                            margin: "0",
                            fontWeight: "normal",
                        }}
                    >
                        Svaka radionica nudi jedinstveno iskustvo prilagođeno
                        različitim nivoima i tehnikama barberinga.
                    </h1>
                </div>
                <h1 style={{ marginTop: "-20px", marginBottom: "-70px" }}>
                    Hands On
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={handsOnImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() => navigate("/educations/single/hands-on")}
                    >
                        Prikaži više
                    </button>
                </div>

                <h1 style={{ marginTop: "60px", marginBottom: "-70px" }}>
                    Look And Learn
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={lookAndLearnImg}
                        style={{
                            width: "80%",
                            height: "400px",
                            objectFit: "cover",
                            objectPosition: "15% center",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() =>
                            navigate("/educations/single/look-and-learn")
                        }
                    >
                        Prikaži više
                    </button>
                </div>

                <h1 style={{ marginTop: "60px", marginBottom: "-70px" }}>
                    One on One
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={oneOnOneImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() =>
                            navigate("/educations/single/one-on-one")
                        }
                    >
                        Prikaži više
                    </button>
                </div>
            </div>
            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
